import MultiRadio from './MultiRadio';
import { useState, useEffect } from 'react';

export default function RadioQuestion({ selected: selectedProp, onChange: onChangeProp, options, name }) {
  // default options if not passed
  const opts = options ?? [
    { value: { number: 0, label: 'en' }, label: 'English' },
    { value: { number: 1, label: 'pt' }, label: 'Português' },
  ];

  const [internal, setInternal] = useState(null);
  const selected = selectedProp !== undefined ? selectedProp : internal;

  useEffect(() => {
    if (selectedProp !== undefined) return;
    // don't auto-select when required - keep null so user must pick
    setInternal(null);
  }, [selectedProp]);

  const handleChange = (v) => {
    if (selectedProp === undefined) setInternal(v);
    if (typeof onChangeProp === 'function') onChangeProp(v);
  };

  return (
    <div className="mt-4">
      <MultiRadio
        name={name}
        layout="vertical"
        options={opts}
        selected={selected}
        onChange={handleChange}
        required={false}
      />
    </div>
  );
}
